:host{position:absolute;height:70px;pointer-events:none;transition:opacity 1s}:host.ag-tooltip-hiding{opacity:0}.custom-tooltip{background-color:#2b1680;border-radius:8px;color:#fff;padding:8px 12px;max-width:700px;overflow-wrap:break-word}
/*# sourceMappingURL=ag-tooltip.component-YPUQP7F4.css.map */
